<div class="container-fluid">
  <form method="post" class="d-flex flex-column gap-3 mt-2">
    <div class="form-floating">
      <select
        class="browser-default form-select"
        name="returnOption"
        [(ngModel)]="selectedReturnOpt"
        (ngModelChange)="resetEverything()"
      >
        @for (o of returnOptions; track o) {
          <option [value]="o">
            {{ o }}
          </option>
        }
      </select>
      <label>Return Type</label>
    </div>

    @if (returnBank != undefined) {
      <div class="form-floating">
        <input
          type="text"
          class="form-control"
          id="returnBank"
          name="returnBank"
          placeholder="Return Bank"
          [(ngModel)]="returnBank"
          required
        />
        <label for="returnBank">Return Bank</label>
      </div>
    }

    <div class="form-floating">
      <input
        type="text"
        class="form-control"
        id="remark"
        name="remark"
        placeholder="Remark"
        [(ngModel)]="remark"
        required
      />
      <label for="remark">Remark / Customer Details</label>
    </div>
    <div class="form-floating">
      <input
        type="number"
        class="form-control"
        id="amount"
        name="amount"
        placeholder="Return Amount"
        [(ngModel)]="amount"
        required
      />
      <label for="amount">Return Amount</label>
    </div>
    @if (selectedReturnOpt == "Customer") {
      <button
        class="btn btn-info"
        type="button"
        (click)="searchCustomerAndFillIn()"
      >
        Auto Fill EPF Customer SETTLEMENT Return
      </button>

      <!--If this is not EPF Customer but need to indicate share return-->
      @if (previousEPFLoans.length == 0) {
        <mat-slide-toggle
          class="mat-slide-toggle-lg"
          [hideIcon]="true"
          color="primary"
          [(ngModel)]="isShared"
          (ngModelChange)="addLoggedInCompanyIntoList()"
          name="isShared"
        >
          Share Return</mat-slide-toggle
        >
      }

      @if (branchDistributionList.length > 0 || isShared == true) {
        <h3>Distribution</h3>
        <app-asset-shared-branch-list
          [(branchDistributionList)]="branchDistributionList"
          [allowAdding]="isShared"
        ></app-asset-shared-branch-list>
        <!-- <table class="table">
            <thead>
                <tr>
                    <th>Branch</th>
                    <th>Distribution</th>
                </tr>
            </thead>

            <tbody>
                @for (d of branchDistributionList; track d;let i=$index) {
                <tr>
                    <td>
                        {{d.appliedBranch.CompanyCode}}
                    </td>
                    <td>

                        <div class="form-floating">
                            <input type="number" class="form-control" [id]="'distributedAmount-' + i"
                                [name]="'distributedAmount-' + i" placeholder="Branch Amount" [(ngModel)]="d.amount"
                                (keypress)="sharedService.isNumberKey($event)" required />
                            <label for="distributedAmount">Branch Amount</label>
                        </div>
                    </td>
                </tr>
                }
            </tbody>
        </table> -->
      }

      <mat-slide-toggle
        class="mat-slide-toggle-lg"
        [hideIcon]="true"
        color="primary"
        [(ngModel)]="needRefund"
        (ngModelChange)="resetRefund()"
        name="needRefund"
      >
        Need to do Refund?</mat-slide-toggle
      >
    }

    @if (needRefund) {
      <div class="row">
        <div class="col-6">
          <div class="form-floating">
            <input
              type="number"
              class="form-control"
              id="refundAmount"
              name="refundAmount"
              placeholder="Refund Amount"
              [(ngModel)]="refundAmount"
              required
            />
            <label for="refundAmount">Refund Amount</label>
          </div>
        </div>
        <div class="col-6">
          @if (bankInAccount == undefined) {
            <button
              type="button"
              class="btn btn-secondary"
              (click)="openAddBankInAccountModal()"
            >
              Add Bank In Account
            </button>
          }
        </div>
      </div>
    }

    @if (bankInAccount != undefined) {
      <b class="text-danger d-flex justify-content-end"
        >*Please check customer total transfer amount before proceed</b
      >
      <table class="table">
        <thead>
          <tr>
            <th>Action</th>
            <th>Remark</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td>Returned by : {{ remark }}</td>
            <td>RM {{ amount | number: "1.2-2" }}</td>
          </tr>
          <tr>
            <td>
              <button
                type="button"
                class="btn btn-danger"
                (click)="removeBank()"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </td>
            <td>
              Refund to : {{ bankInAccount.HolderName }} ({{
                bankInAccount.Bank
              }}
              - {{ bankInAccount.AccountNumber }})
            </td>
            <td>RM {{ refundAmount | number: "1.2-2" }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th></th>
            <th>Total:</th>
            <th>RM {{ amount + refundAmount | number: "1.2-2" }}</th>
          </tr>
        </tfoot>
      </table>
    }
  </form>
  <div class="d-flex justify-content-end">
    <button
      class="btn btn-success"
      (click)="submit()"
      [disabled]="disableSubmit"
    >
      Submit
    </button>
  </div>
</div>
